module.exports = __webpack_public_path__ + "static/Background-scot-4.68732f0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-scot-4.jpg
// module id = 477
// module chunks = 153228935106781